var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 1.15C6.4 0.514872 6.93726 0 7.6 0H12.4C13.0627 0 13.6 0.514872 13.6 1.15C13.6 1.78513 13.0627 2.3 12.4 2.3H7.6C6.93726 2.3 6.4 1.78513 6.4 1.15ZM10 6.13333C5.80264 6.13333 2.4 9.39419 2.4 13.4167C2.4 17.4391 5.80264 20.7 10 20.7C14.1974 20.7 17.6 17.4391 17.6 13.4167C17.6 9.39419 14.1974 6.13333 10 6.13333ZM0 13.4167C0 8.12394 4.47715 3.83333 10 3.83333C15.5228 3.83333 20 8.12394 20 13.4167C20 18.7094 15.5228 23 10 23C4.47715 23 0 18.7094 0 13.4167ZM14.2426 9.35081C14.7113 9.79992 14.7113 10.5281 14.2426 10.9772L10.8485 14.2298C10.3799 14.6789 9.6201 14.6789 9.15147 14.2298C8.68284 13.7807 8.68284 13.0526 9.15147 12.6035L12.5456 9.35081C13.0142 8.90171 13.774 8.90171 14.2426 9.35081Z",
    fill: "#56B9AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.0fcc0fca.svg";
export { ForwardRef as ReactComponent };